module.exports = __webpack_public_path__ + "static/l1_large-f9e8d8bd6316e3322030e2023e8277ba.jpg";